import React from "react";
import FlatButton from "material-ui/FlatButton";
import { cancelOrderLine } from "../../redux/modules/ordersDuck";
import { connectWithLifecycle } from "react-lifecycle-component";

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  handleCancelOrderLine: () => {
    dispatch(cancelOrderLine());
  }
});

export const CancelOrderList = ({ handleCancelOrderLine }) => {
  return (
    <FlatButton label="Cancelar" onClick={() => handleCancelOrderLine()} />
  );
};

const CancelOrderListButton = connectWithLifecycle(
  mapStateToProps,
  mapDispatchToProps
)(CancelOrderList);

export default CancelOrderListButton;



// WEBPACK FOOTER //
// ./src/components/container/CancelOrderLineButton.js